import React from 'react';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
    return (
        <div className="container mx-auto px-6 py-24 max-w-4xl">
            {/* Breadcrumb */}
            <nav className="text-sm mb-12">
                <Link to="/" className="text-text-muted hover:text-dark-primary">Inicio</Link>
                <span className="mx-2 text-text-muted">/</span>
                <span className="text-dark-primary font-medium">Términos y Condiciones</span>
            </nav>

            <h1 className="text-4xl md:text-5xl font-display font-bold text-dark-primary mb-8">
                Términos y Condiciones
            </h1>

            <div className="prose prose-sm max-w-none text-text-muted space-y-6">
                <p className="text-sm">
                    Los presentes Términos y Condiciones regulan el acceso y uso del sitio web 
                    <strong> www.jcbazteca.com</strong> (en adelante el "Sitio"), propiedad de 
                    <strong> JCB AZTECA S.A. de C.V.</strong> (en adelante "JCB Azteca"). 
                    Al utilizar este Sitio, usted acepta los términos y condiciones aquí establecidos.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    1. Información General
                </h2>
                <p className="text-sm">
                    JCB Azteca es una empresa dedicada a la distribución y comercialización de maquinaria 
                    de construcción, refacciones y servicios relacionados, operando en el Sureste de México.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    2. Uso del Sitio
                </h2>
                <p className="text-sm">
                    El usuario se compromete a utilizar el Sitio de manera lícita y conforme a las disposiciones 
                    de estos Términos y Condiciones, así como a las leyes aplicables. Queda prohibido:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                    <li>Utilizar el Sitio para fines ilegales o no autorizados</li>
                    <li>Introducir virus, malware o cualquier otro código dañino</li>
                    <li>Intentar acceder a áreas restringidas del Sitio sin autorización</li>
                    <li>Realizar actividades que afecten la disponibilidad o integridad del Sitio</li>
                    <li>Recopilar información de otros usuarios sin su consentimiento</li>
                </ul>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    3. Propiedad Intelectual
                </h2>
                <p className="text-sm">
                    Todos los contenidos del Sitio, incluyendo textos, imágenes, logotipos, diseños, videos, 
                    y demás materiales, son propiedad de JCB Azteca o de sus licenciantes y están protegidos 
                    por las leyes de propiedad intelectual aplicables.
                </p>
                <p className="text-sm">
                    Queda prohibida la reproducción, distribución, modificación o uso no autorizado de los 
                    contenidos del Sitio sin el consentimiento expreso de JCB Azteca.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    4. Productos y Servicios
                </h2>
                <p className="text-sm">
                    La información sobre productos y servicios presentada en el Sitio es de carácter informativo 
                    y no constituye una oferta vinculante. JCB Azteca se reserva el derecho de modificar las 
                    especificaciones, precios y disponibilidad de los productos sin previo aviso.
                </p>
                <p className="text-sm">
                    Las imágenes de los productos pueden variar ligeramente de los productos reales. 
                    Para información precisa, recomendamos contactar directamente a nuestros asesores.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    5. Cotizaciones y Pedidos
                </h2>
                <p className="text-sm">
                    Las cotizaciones proporcionadas a través del Sitio son estimaciones y no constituyen 
                    una oferta firme. Los pedidos están sujetos a confirmación de disponibilidad y condiciones 
                    comerciales vigentes al momento de la compra.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    6. Limitación de Responsabilidad
                </h2>
                <p className="text-sm">
                    JCB Azteca no será responsable por daños directos, indirectos, incidentales o consecuentes 
                    derivados del uso o imposibilidad de uso del Sitio, incluyendo pero no limitado a:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                    <li>Interrupciones en el servicio</li>
                    <li>Pérdida de datos o información</li>
                    <li>Errores u omisiones en el contenido</li>
                    <li>Actos de terceros no controlados por JCB Azteca</li>
                </ul>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    7. Enlaces a Terceros
                </h2>
                <p className="text-sm">
                    El Sitio puede contener enlaces a sitios web de terceros. JCB Azteca no se responsabiliza 
                    por el contenido, políticas de privacidad o prácticas de dichos sitios. El acceso a estos 
                    enlaces es bajo responsabilidad del usuario.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    8. Modificaciones
                </h2>
                <p className="text-sm">
                    JCB Azteca se reserva el derecho de modificar estos Términos y Condiciones en cualquier 
                    momento. Los cambios serán publicados en el Sitio y entrarán en vigor a partir de su 
                    publicación. Se recomienda revisar periódicamente este documento.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    9. Legislación Aplicable
                </h2>
                <p className="text-sm">
                    Estos Términos y Condiciones se rigen por las leyes de los Estados Unidos Mexicanos. 
                    Cualquier controversia derivada del uso del Sitio será resuelta ante los tribunales 
                    competentes en Villahermosa, Tabasco.
                </p>

                <h2 className="text-xl font-display font-bold text-dark-primary mt-8 mb-4">
                    10. Contacto
                </h2>
                <p className="text-sm">
                    Si tiene alguna pregunta sobre estos Términos y Condiciones, puede contactarnos a través de:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-sm">
                    <li><strong>Correo electrónico:</strong> contacto@jcbazteca.com</li>
                    <li><strong>Teléfono:</strong> +52 (993) 478 4100</li>
                    <li><strong>Domicilio:</strong> Carr. Vhsa-Cardenas Ría. Anacleto Canabal Km. 0. 800, 86280 Villahermosa, Tab.</li>
                </ul>

                <p className="text-sm text-text-subtle mt-8">
                    <strong>Última actualización:</strong> Septiembre de 2026
                </p>
            </div>
        </div>
    );
};

export default TermsConditions;